import React from 'react'

import { Box } from 'ui/components/Box'
import { ColorScheme } from 'ui/styling/baseVariables/colors/colorPalette'
import { Breakpoint } from 'ui/styling/helpers/breakpoints'
import { adminTheme, darkTheme, lightTheme, onboardingTheme } from 'ui/styling/Theme.css'

import makeAdminThemeVariables from './admin'
import makeDefaultThemeVariables from './default'

export type ThemeName = 'default' | 'dark' | 'admin' | 'onboarding'
export type ThemeProviderRef = HTMLDivElement
export type ThemeProviderProps = React.ComponentPropsWithoutRef<typeof Box> & {
    theme?: ThemeName
}
export type ThemeContextValue = {
    theme: ThemeName
    themeClassName: string | undefined
    themeRawVariables: ReturnType<typeof mapThemeNameToRawVariables>
    breakpoint: Breakpoint
    colorScheme: ColorScheme
    setColorScheme: (colorScheme: ColorScheme) => void
}

export function mapThemeNameToRawVariables(themeName: ThemeName) {
    switch (themeName) {
        case 'admin':
            return makeAdminThemeVariables()
        case 'onboarding':
            return makeAdminThemeVariables()
        default:
            return makeDefaultThemeVariables()
    }
}

export type Theme = {
    id: ThemeName
    className: string
    rawVariables: ReturnType<typeof mapThemeNameToRawVariables>
}

export const themes: Record<ThemeName, Theme> = {
    default: {
        id: 'default',
        className: lightTheme,
        rawVariables: mapThemeNameToRawVariables('default'),
    },
    dark: {
        id: 'dark',
        className: darkTheme,
        rawVariables: mapThemeNameToRawVariables('dark'),
    },
    admin: {
        id: 'admin',
        className: adminTheme,
        rawVariables: mapThemeNameToRawVariables('admin'),
    },
    onboarding: {
        id: 'onboarding',
        className: onboardingTheme,
        rawVariables: mapThemeNameToRawVariables('onboarding'),
    },
}
